import React from "react";
import "./styles.scss";

const Setupstaff = () => {
  return (
    <div className="container">
      <h2 className="title">Setup staff</h2>
      <p className="description">
        Invite team members and assign roles to help you manage your stores
        efficiently.
      </p>
    </div>
  );
};

export default Setupstaff;
